import { FaUserShield, FaUsers, FaUniversalAccess, FaQuestionCircle } from 'react-icons/fa';
import React, { useState, useEffect } from 'react';
import Navbar from '../../composant_reutilisable/navbar';
import Sidebar from '../../composant_reutilisable/sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { BsPeople } from 'react-icons/bs';
import useAuth from '../../composant_reutilisable/useAuth';
import Elementaires from '../elementaires/elementaires';
import axios from 'axios';
import Pas_acces from '../../composant_reutilisable/pas_acces';

const ConfigurerGroupe = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('userId');
    const { groupe_id } = location.state || {};

    const [activeSection, setActiveSection] = useState('infos'); // Nouveau state pour gérer les sections
    const [groupeData, setGroupeData] = useState({});
    const [groupeUsers, setGroupeUsers] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [selectedGroupeUsers, setSelectedGroupeUsers] = useState([]);
    const [selectedAllUsers, setSelectedAllUsers] = useState([]);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [searchGroupe, setSearchGroupe] = useState('');
    const [searchAll, setSearchAll] = useState('');
    const [groupeAcces, setGroupeAcces] = useState(null);
    const [isLoadingGlobale, setIsLoadingGlobale] = useState(false);

    const [userData, setUserData] = useState([]);


    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Configurer Groupe";
        }
    }, [user_id]);

    useEffect(() => {
        setIsLoadingGlobale(true)
        const fetchUserData = async () => {
            const token = localStorage.getItem('access_token');
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    });
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                setUserData(data);
                setIsLoadingGlobale(false)
            } catch (error) {
                console.error('Erreur lors de la récupération des données utilisateur:', error);
            }
        };

        fetchUserData();
    }, [user_id]);



    // const modules = {
    //     toolbar: [
    //         [{ 'header': [1, 2, false] }],
    //         ['bold', 'italic', 'underline'],
    //         ['link', 'image'],
    //         [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    //         ['clean'],
    //         [{ 'align': [] }],
    //     ],
    // };


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 10000);
    };


    const fetchGroupeData = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(process.env.REACT_APP_HOTE + `/groupe-info/${groupe_id}/`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
            if (response.ok) {
                const data = await response.json();
                setGroupeData(data);
            } else {
                const data = await response.json();
                console.error('Erreur lors de la récupération des données du groupe', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {

        fetchGroupeData();
    }, [groupe_id]);


    const fetchUsers = async () => {
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/afficher-utilisateurs-du-groupe/${groupe_id}/`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
            if (response.ok) {
                const data = await response.json();
                setGroupeUsers(data.utilisateurs_du_groupe);
                // console.log(groupeUsers)
                setAllUsers(data.tous_utilisateurs);
            } else {
                console.error('Erreur lors de la récupération des utilisateurs');
            }
        } catch (error) {
            console.error('Erreur:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [groupe_id]);

    const ajouterTous = () => {
        setGroupeUsers([...groupeUsers, ...allUsers]);
        setAllUsers([]);
    };

    const ajouterSelection = () => {
        const selectedUsers = allUsers.filter(user => selectedAllUsers.includes(user.id));
        setGroupeUsers([...groupeUsers, ...selectedUsers]);
        setAllUsers(allUsers.filter(user => !selectedAllUsers.includes(user.id)));
        setSelectedAllUsers([]);
    };

    const retirerSelection = () => {
        const selectedUsers = groupeUsers.filter(user => selectedGroupeUsers.includes(user.id));
        setAllUsers([...allUsers, ...selectedUsers]);
        setGroupeUsers(groupeUsers.filter(user => !selectedGroupeUsers.includes(user.id)));
        setSelectedGroupeUsers([]);
    };

    const retirerTous = () => {
        setAllUsers([...allUsers, ...groupeUsers]);
        setGroupeUsers([]);
    };

    const handleSubmit = async () => {
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-utilisateurs-groupe/${groupe_id}/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    utilisateurs_ids: groupeUsers.map(user => user.id)
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
                fetchGroupeData();
                showAlert(errorData);

            } else {
                const responseData = await response.json();
                showAlert('Configuration faite avec succès.');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Erreur lors de l\'enregistrement des utilisateurs.');
        }
    };


    const filteredGroupeUsers = groupeUsers.filter(user =>
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(searchGroupe.toLowerCase()) ||
        user.email.toLowerCase().includes(searchGroupe.toLowerCase())
    );

    const filteredAllUsers = allUsers.filter(user =>
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(searchAll.toLowerCase()) ||
        user.email.toLowerCase().includes(searchAll.toLowerCase())
    );

    const handleModifier = async (event) => {
        event.preventDefault();
        const formData = {
            titre: groupeData.titre,
            description: groupeData.description,
            type_groupe: groupeData.type_groupe
        };

        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-groupe/${groupe_id}/${user_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const data = await response.json();
                showAlert('Modification éffectuée avec succès');
                fetchGroupeData();
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };


    const [acces, setAcces] = useState({
        Utilisateurs: false,
        Administration: false,
        Paiement: false,
        Groupes: false,
        Dashboard: false,
        Enrolement: false,
        EnrolementAdmin: false,
        ListePiecesAdmin: false,
        Elementaires: false,
        Suivi_doc: false,
        Gestion_tours_national: false,
        Gestion_tours_international: false,
        Mise_en_file: false,
        Parametres: false,
        Fret: false,
        Journalisation: false,
        Corbeille: false,
        Rapport_et_statistique: false,
        Liste_Fifo: false,
        Liste_Chargement: false,
        Liste_Lettre_voiture: false,
        Liste_camion_comptabilite: false,

        Parc_tampon: false,
        Supervision: false,

        Gie: false,
    });

    // Initialiser les accès en fonction de groupeAcces
    useEffect(() => {
        if (groupeAcces && Array.isArray(groupeAcces) && groupeAcces.length > 0) {
            // Récupérer la chaîne acces du premier élément
            const accesString = groupeAcces[0].acces;

            try {
                // Corriger les apostrophes et parser en tableau
                const accesArray = JSON.parse(accesString.replace(/'/g, '"'));

                const newAcces = {
                    Utilisateurs: accesArray.includes('Utilisateurs'),
                    Administration: accesArray.includes('Administration'),
                    Paiement: accesArray.includes('Paiement'),
                    Groupes: accesArray.includes('Groupes'),
                    Dashboard: accesArray.includes('Dashboard'),
                    Enrolement: accesArray.includes('Enrolement'),
                    EnrolementAdmin: accesArray.includes('EnrolementAdmin'),
                    ListePiecesAdmin: accesArray.includes('ListePiecesAdmin'),
                    Suivi_doc: accesArray.includes('Suivi_doc'),
                    Gestion_tours_national: accesArray.includes('Gestion_tours_national'),
                    Gestion_tours_international: accesArray.includes('Gestion_tours_international'),
                    Mise_en_file: accesArray.includes('Mise_en_file'),
                    Elementaires: accesArray.includes('Elementaires'),
                    Parametres: accesArray.includes('Parametres'),
                    Fret: accesArray.includes('Fret'),
                    Journalisation: accesArray.includes('Journalisation'),
                    Corbeille: accesArray.includes('Corbeille'),
                    Rapport_et_statistique: accesArray.includes('Rapport_et_statistique'),
                    Liste_Fifo: accesArray.includes('Liste_Fifo'),
                    Liste_Chargement: accesArray.includes('Liste_Chargement'),
                    Liste_Lettre_voiture: accesArray.includes('Liste_Lettre_voiture'),
                    Liste_camion_comptabilite: accesArray.includes('Liste_camion_comptabilite'),

                    Parc_tampon: accesArray.includes('Parc_tampon'),
                    Supervision: accesArray.includes('Supervision'),

                    Gie: accesArray.includes('Gie'),
                };

                setAcces(newAcces);
            } catch (error) {
                console.error("Erreur lors du parsing de l'accès :", error);
            }
        } else {
            // console.log("Format de groupeAcces invalide ou accès non défini.");
            // console.log('aceessssss',groupeAcces)

            const newAcces = {
                Utilisateurs: false,
                Administration: false,
                Groupes: false,
                Dashboard: false,
                Enrolement: false,
                EnrolementAdmin: false,
                ListePiecesAdmin: false,
                Suivi_doc: false,
                Gestion_tours_national: false,
                Gestion_tours_international: false,
                Mise_en_file: false,
                Elementaires: false,
                Parametres: false,
                Fret: false,
                Corbeille: false,
                Rapport_et_statistique: false,
                Liste_Fifo: false,
                Liste_Chargement: false,
                Liste_Lettre_voiture: false,
                Liste_camion_comptabilite: false,

                Parc_tampon: false,
                Supervision: false,
                Gie: false,
            };

            setAcces(newAcces);
        }
    }, [groupeAcces]);


    const handleCheckboxAccesChange = (e) => {
        const { name, checked } = e.target;
        setAcces((prevAcces) => ({
            ...prevAcces,
            [name]: checked,
        }));
    };

    const generateAccesArray = () => {
        return Object.keys(acces).filter(key => acces[key]); // Retourner le tableau des accès
    };

    const handleSave = () => {
        const accesArray = generateAccesArray();
        handleAccesChange(accesArray); // Envoyer le tableau au parent
        // handleClose(); // Fermer le modal après l'enregistrement
    };

    const handleAccesChange = async (accesString) => {
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-acces-groupe/${groupe_id}/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ acces: accesString }),
            });

            if (response.ok) {
                const responseData = await response.json();

                showAlert('Accès enregistrés avec succès !');
            } else {
                const errorData = await response.json();
                console.error('Erreur lors de l\'enregistrement des accès:', errorData);
            }

        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const fetchGroupeAcces = async () => {
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/groupe-acces/${groupe_id}/`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
            if (response.ok) {
                const data = await response.json();
                setGroupeAcces(data.acces);
                // console.log('aceessssss22222222',data.acces)
            } else {
                console.error('Erreur lors de la récupération des accès du groupe');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };


    useEffect(() => {
        if (user_id) {
            fetchGroupeAcces();
        }
    }, []);


    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            const token = localStorage.getItem('access_token')
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`,
                    {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Groupes")) {
        return (
            <Pas_acces />
        );
    }


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <BsPeople size={25} className='mr-2' />Configurer groupe {groupeData.titre}
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                className="btn btn-link p-0 ml-2"
                                title="Manuel d'utilisation"
                                onClick={() => navigate('/Manuel-utilisation-admin', {
                                    state: {
                                        fromModule: 'administration',
                                        fromSection: 'groupes'
                                    }
                                })}
                            >
                                <FaQuestionCircle size={18} />
                            </button> */}
                            </h2>
                            <small>Administration des groupes d'utilisateurs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-groupe`}>Groupes</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Configurer groupe  {groupeData.titre}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert mt-3 alert-${alert.type}`} role="alert"
                            dangerouslySetInnerHTML={{ __html: alert.message }} />
                    )}

                    <div className="container-fluid">
                        <div className="container mt-3 mb-5">
                            <div className="row">
                                <div className="col-md-3 ibox-content border-end mr-4 ml-4" style={{ borderRadius: "15px" }}>
                                    <div className="btn-group-vertical w-100 text-start">
                                        <button
                                            className={`btn text-start py-2 d-flex align-items-center ${activeSection === 'infos' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('infos')}
                                        >
                                            <FaUserShield className="me-2 ml-2 mr-2" />
                                            <span>Infos</span>
                                        </button>
                                        <button
                                            className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'acces' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('acces')}
                                        >
                                            <FaUniversalAccess className="me-2 ml-2 mr-2" />
                                            <span>Accès</span>
                                        </button>
                                        <button
                                            className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'membres' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('membres')}
                                        >
                                            <FaUsers className="me-2 ml-2 mr-2" />
                                            <span>Membres ({groupeUsers.length || '0'})</span>
                                        </button>
                                    </div>
                                </div>

                                {!isLoadingGlobale ? (

                                    <div className="col-md-8 ibox-content" style={{ borderRadius: "15px" }}>
                                        {activeSection === 'infos' && (
                                            <div className=''>
                                                <div className="ibox-title">
                                                    <h4>Modifier le groupe</h4>
                                                </div>
                                                <div className="ibox-content">
                                                    <form className="m-t" role="form" encType="multipart/form-data">
                                                        {/* Formulaire pour le nom */}
                                                        <div className="form-group">
                                                            <label>Titre*</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                required
                                                                name="titre"
                                                                value={groupeData.titre || ''}
                                                                onChange={(e) => setGroupeData({ ...groupeData, titre: e.target.value })}
                                                            />
                                                        </div>

                                                        {/* Formulaire pour la description avec Quill */}
                                                        <div className="form-group">
                                                            <label>Description</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                required
                                                                name="description"
                                                                value={groupeData.description || ''}
                                                                onChange={(e) => setGroupeData({ ...groupeData, description: e.target.value })}
                                                            />
                                                        </div>
                                                        {/* <div className="form-group">
                                                            <label>Type du groupe*</label>
                                                            <select
                                                                className="form-control m-b"
                                                                name="type_groupe"
                                                                value={groupeData.type_groupe}
                                                                onChange={(e) => setGroupeData({ ...groupeData, type_groupe: e.target.value })}
                                                            >
                                                                <option value="Cohorte">Cohorte</option>
                                                                <option value="Groupe système">Groupe système</option>
                                                            </select>
                                                        </div> */}
                                                    </form>
                                                </div>
                                                <div className="text-center mt-4">
                                                    <button type="submit" className="btn btn-success" onClick={handleModifier}>
                                                        <strong>Enregistrer</strong>

                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        {activeSection === 'acces' && (
                                            <div className="" key={JSON.stringify(acces)}>
                                                <div className='ibox-title'>
                                                    <h4>Définir les accès</h4>
                                                </div>
                                                <div className='ibox-content'>
                                                    {/* Accès Utilisateurs */}
                                                    <div className='mb-5'>
                                                        <h3>Accès Utilisateurs</h3>
                                                        <Form className='row mt-3'>
                                                            {/* <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Suivi document"
                                                                        name="Suivi_doc"
                                                                        checked={acces.Suivi_doc}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div> */}
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Rapport et statistique"
                                                                        name="Rapport_et_statistique"
                                                                        checked={acces.Rapport_et_statistique}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Mise en file"
                                                                        name="Mise_en_file"
                                                                        checked={acces.Mise_en_file}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Fret"
                                                                        name="Fret"
                                                                        checked={acces.Fret}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Form>
                                                        <Form className='row mt-3'>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Liste Fifo"
                                                                        name="Liste_Fifo"
                                                                        checked={acces.Liste_Fifo}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Liste Chargement"
                                                                        name="Liste_Chargement"
                                                                        checked={acces.Liste_Chargement}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Liste Lettre voiture"
                                                                        name="Liste_Lettre_voiture"
                                                                        checked={acces.Liste_Lettre_voiture}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Form>
                                                        <Form className='row mt-3'>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Parc tampon"
                                                                        name="Parc_tampon"
                                                                        checked={acces.Parc_tampon}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="GIE"
                                                                        name="Gie"
                                                                        checked={acces.Gie}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Supervision général"
                                                                        name="Supervision"
                                                                        checked={acces.Supervision}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Form>
                                                    </div>

                                                    {/* Accès Administrateurs */}
                                                    <div>
                                                        <h3>Accès Administrateurs</h3>
                                                        <Form className='row mt-3'>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Administration"
                                                                        name="Administration"
                                                                        checked={acces.Administration}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Utilisateurs"
                                                                        name="Utilisateurs"
                                                                        checked={acces.Utilisateurs}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Groupes"
                                                                        name="Groupes"
                                                                        checked={acces.Groupes}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Form>
                                                        <Form className='row mt-3'>
                                                            {/* <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Enrolement Admin"
                                                                        name="EnrolementAdmin"
                                                                        checked={acces.EnrolementAdmin}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div> */}
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Elémentaires"
                                                                        name="Elementaires"
                                                                        checked={acces.Elementaires}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Paramètres"
                                                                        name="Parametres"
                                                                        checked={acces.Parametres}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Journalisation"
                                                                        name="Journalisation"
                                                                        checked={acces.Journalisation}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Form>
                                                        <Form className='row mt-3'>
                                                            {/* <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Corbeille"
                                                                        name="Corbeille"
                                                                        checked={acces.Corbeille}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div> */}
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Suivi Documents Admin"
                                                                        name="ListePiecesAdmin"
                                                                        checked={acces.ListePiecesAdmin}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Form>
                                                        {/* <Form className='row mt-3'>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Paiement"
                                                                        name="Paiement"
                                                                        checked={acces.Paiement}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Form> */}
                                                    </div>
                                                </div>



                                                {/* Buttons */}
                                                <div className="d-flex justify-content-center mt-4">
                                                    <Button variant="success" onClick={handleSave}>
                                                        <strong>Enregistrer</strong>
                                                    </Button>
                                                </div>
                                            </div>
                                        )}

                                        {activeSection === 'membres' && (
                                            <div>
                                                <div className='ibox-title'>
                                                    <h4>Gérer les membres du groupe</h4>
                                                </div>
                                                <div className='ibox-content'>

                                                    {/* Liste des utilisateurs déjà ajoutés au groupe */}
                                                    <div className="row justify-content-center">
                                                        <div className="col-md-4">
                                                            {/* Recherche d'utilisateurs */}
                                                            <div className="d-flex mb-4">
                                                                <input
                                                                    type="text"
                                                                    placeholder="Rechercher..."
                                                                    value={searchAll}
                                                                    onChange={(e) => setSearchAll(e.target.value)}
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <h5>Utilisateurs disponibles</h5>
                                                            <select
                                                                multiple
                                                                value={selectedAllUsers}
                                                                onChange={(e) => setSelectedAllUsers([...e.target.selectedOptions].map(option => parseInt(option.value)))}
                                                                className="form-control"
                                                                style={{
                                                                    height: '320px',
                                                                    padding: '10px',
                                                                    borderRadius: '8px',
                                                                    border: '1px solid #ccc',
                                                                    backgroundColor: '#f9f9f9',
                                                                    color: '#333',
                                                                    fontSize: '16px',
                                                                    marginBottom: '20px',
                                                                }}
                                                            >
                                                                {filteredAllUsers.map(user => (
                                                                    <option key={user.id} value={user.id}>
                                                                        {user.nom} {user.prenoms}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Boutons d'actions pour ajouter ou retirer des utilisateurs */}
                                                        <div className="col-md-4 d-flex flex-column justify-content-center">
                                                            {/* <button onClick={ajouterTous} className="btn btn-dark mb-2">
                                                                {"Ajouter tous >>"}
                                                            </button> */}
                                                            <button onClick={ajouterSelection} className="btn btn-dark mb-2">
                                                                {"Ajouter sélection >"}
                                                            </button>
                                                            <button onClick={retirerSelection} className="btn btn-dark mb-2">
                                                                {"< Retirer sélection"}
                                                            </button>
                                                            {/* <button onClick={retirerTous} className="btn btn-dark">
                                                                {"<< Retirer tous"}
                                                            </button> */}
                                                        </div>

                                                        {/* Liste des utilisateurs disponibles à ajouter */}
                                                        <div className="col-md-4">
                                                            {/* Recherche d'utilisateurs */}
                                                            <div className="d-flex mb-4">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Rechercher..."
                                                                    value={searchGroupe}
                                                                    onChange={(e) => setSearchGroupe(e.target.value)}
                                                                />
                                                            </div>
                                                            <h5>Utilisateurs du groupe</h5>
                                                            <select
                                                                multiple
                                                                value={selectedGroupeUsers}
                                                                onChange={(e) => setSelectedGroupeUsers([...e.target.selectedOptions].map(option => parseInt(option.value)))}
                                                                className="form-control"
                                                                style={{
                                                                    height: '320px',
                                                                    padding: '10px',
                                                                    borderRadius: '8px',
                                                                    border: '1px solid #ccc',
                                                                    backgroundColor: '#f9f9f9',
                                                                    color: '#333',
                                                                    fontSize: '16px',
                                                                    marginBottom: '20px',
                                                                }}
                                                            >
                                                                {filteredGroupeUsers.map(user => (
                                                                    <option key={user.id} value={user.id}>
                                                                        {user.nom} {user.prenoms}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>


                                                {/* Formulaire pour enregistrer les modifications */}
                                                <div className="text-center mt-4">
                                                    <button onClick={handleSubmit} className="btn btn-success">
                                                        <strong>Enregistrer</strong>
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="col-md-8 ibox-content" style={{ borderRadius: "15px" }}>
                                        <span
                                            className="spinner-border spinner-border-lg text-success"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    </div>

                                )}

                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        {/* <div className="float-right">
                        10GB of <strong>250GB</strong> Free.
                    </div> */}
                        <div>
                            <strong><a href="https://www.adnservicespro.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>ADN Services</a></strong> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>INOVACT SARL</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfigurerGroupe;
